<template>
  <div class="coupon-material">
    <vh-dialog
      :title="$t('host.k_576001')"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :modal="false"
      width="820px"
    >
      <div class="coupon-material-list">
        <div v-if="isSearch || total">
          <div class="coupon-material-header">
            <vh-input
              class="fr"
              round
              :maxlength="50"
              size="medium"
              style="width: 180px"
              :placeholder="$t('host.k_576002')"
              v-clearEmoij
              v-model="keyword"
              @keyup.enter.native="getList($event, true)"
              clearable
              @clear="getList(true)"
            >
              <i
                class="vh-icon-search vh-input__icon"
                slot="prefix"
                @click="getList($event, true)"
              ></i>
            </vh-input>
          </div>
          <component
            :is="choseType == 'checkbox' ? 'div' : 'radioGroup'"
            :value.sync="currentRadio"
          >
            <!-- 表格 -->
            <vh-table
              ref="elTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              height="374px"
              v-loadMore="moreLoadData"
              @selection-change="changeDialogCheck"
              @select-all="checkAllRow"
            >
              <vh-table-column
                v-if="choseType == 'checkbox'"
                type="selection"
                width="55"
                align="left"
              />
              <vh-table-column v-else width="55">
                <template slot-scope="scope">
                  <vh-radio :label="scope.row.coupon_id"></vh-radio>
                </template>
              </vh-table-column>
              <vh-table-column
                :label="$t('host.k_576003')"
                prop="coupon_name"
                width="150"
                show-overflow-tooltip
              ></vh-table-column>
              <vh-table-column :label="$t('host.k_576004')" minWidth="150">
                <template slot-scope="scope">
                  <span>
                    {{ typeFilter(scope.row.coupon_type) }}
                  </span>
                </template>
              </vh-table-column>
              <vh-table-column :label="$t('host.k_576005')" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.coupon_type == 0">
                    {{
                      $t('host.k_576006', [scope.row.threshold_amount, scope.row.deduction_amount])
                    }}
                  </span>
                  <span v-if="scope.row.coupon_type == 1">
                    {{ $t('host.k_576007') }}{{ scope.row.deduction_amount }}
                  </span>
                </template>
              </vh-table-column>
              <vh-table-column :label="$t('host.k_576008')" width="130">
                <template slot-scope="scope">
                  <span
                    :class="{ highLight: scope.row.applicable_product_type != 0 }"
                    @click="openGoodsList(scope.row)"
                  >
                    {{ productFilter(scope.row.applicable_product_type) }}
                    {{ scope.row.applicable_product_type != 0 ? scope.row.goods_num : '' }}
                  </span>
                </template>
              </vh-table-column>
              <vh-table-column :label="$t('host.k_576009')" width="184">
                <template slot-scope="scope">
                  <div v-if="scope.row.validity_type == 0">
                    <p>{{ $t('host.k_576010') }}{{ scope.row.validity_start_time }}</p>
                    <p>{{ $t('host.k_576011') }}{{ scope.row.validity_end_time }}</p>
                  </div>
                  <span v-if="scope.row.validity_type == 1">
                    {{ $t('host.k_576012', [scope.row.validity_day]) }}
                  </span>
                </template>
              </vh-table-column>
              <div slot="empty">
                <null-page :nullType="'search'" v-if="!total"></null-page>
              </div>
            </vh-table>
          </component>
        </div>
        <null-page :nullType="'nullData'" :text="$t('host.k_576013')" v-else></null-page>
        <div class="coupon-material-footer" v-if="isSearch || total">
          <span class="footer-desc">
            <i18n path="host.k_576014">
              <template>
                <b>{{ choseType == 'checkbox' ? selectCoupons.length : currentRadio ? 1 : 0 }}</b>
              </template>
            </i18n>
          </span>
          <div>
            <vh-button
              v-preventReClick
              type="primary"
              round
              size="medium"
              @click="saveCheckHandle"
              :disabled="
                choseType == 'checkbox'
                  ? !(selectCoupons && selectCoupons.length > 0)
                  : !currentRadio
              "
            >
              {{ $t('host.k_576015') }}
            </vh-button>
            <vh-button plain round size="medium" @click="cancel">
              {{ $t('host.k_576016') }}
            </vh-button>
          </div>
        </div>
      </div>
    </vh-dialog>
    <Goods ref="goods" :couponId="curCouponId"></Goods>
  </div>
</template>

<script>
  import NullPage from '../components/nullPage.vue';
  import radioGroup from '../components/radioGroup.vue';
  import Goods from './goods.vue';
  import { useLotteryServer } from 'middle-domain';
  export default {
    name: 'CouponMaterial',
    components: {
      NullPage,
      radioGroup,
      Goods
    },
    props: {
      selectedIds: {
        type: Array,
        default: () => {
          return [];
        }
      },
      choseType: {
        type: String,
        default: 'checkbox' // radio
      }
    },
    data() {
      return {
        selectTotal: 0,
        dialogVisible: false,
        total: 0,
        isSearch: false,
        isCheckAll: false,
        tableData: [],
        selectCoupons: [],
        keyword: '',
        pageInfo: {
          page: 1,
          limit: 10
        },
        totalPages: 0,
        currentRadio: '',
        curCouponId: ''
      };
    },
    watch: {
      selectCoupons(newVal, oldVal) {
        this.$nextTick(() => {
          // this.readonlyTable();
        });
      }
    },
    methods: {
      typeFilter(val) {
        const map = {
          0: this.$t('host.k_576017'),
          1: this.$t('host.k_576018')
        };
        return map[val];
      },
      productFilter(val) {
        const map = {
          0: this.$t('host.k_576019'),
          1: this.$t('host.k_576020'),
          2: this.$t('host.k_576021')
        };
        return map[val];
      },
      handleClose(done) {
        this.pageInfo.page = 1;
        this.tableData = [];
        done();
      },
      moreLoadData() {
        if (this.pageInfo.page >= this.totalPages) {
          return false;
        }
        this.pageInfo.page++;
        this.getList();
      },
      // 获取资料库-弹出框内容
      getList(isClear, isInit) {
        this.isSearch = this.keyword ? true : false;
        if (isClear) {
          this.tableData = [];
          this.pageInfo.page = 1;
        }
        let params = {
          pos: (this.pageInfo.page - 1) * this.pageInfo.limit,
          limit: this.pageInfo.limit,
          keyword: this.keyword
        };

        this.lotteryServer
          .lotteryCouponList(params)
          .then(res => {
            if (res && res.code === 200) {
              if (this.choseType == 'checkbox') {
                if (isInit) {
                  if (this.selectedIds.length) {
                    this.selectCoupons = this.selectedIds;
                  }
                } else {
                  const diff = this.selectedIds.filter(item => {
                    return !this.tableData.some(i => {
                      return item == i.coupon_id;
                    });
                  });
                  this.selectCoupons = this.selectCoupons.concat(...diff);
                }
              }

              this.tableData.push(...(res.data.list || []));
              this.total = res.data.total;
              this.totalPages = Math.ceil(res.data.total / this.pageInfo.limit);
              if (this.isCheckAll) {
                this.$refs.elTable.toggleAllSelection();
              }
            } else {
              this.$vhMessage.error(res.msg);
            }
          })
          .finally(() => {
            if (this.choseType == 'checkbox') {
              // this.readonlyTable();
            }
          });
      },
      // 改变资料库-弹出框内容
      changeDialogCheck(val) {
        // console.log(val);
        this.selectCoupons = val.map(item => item.coupon_id);
      },
      checkAllRow(selection) {
        console.log('全选与非全选', selection);
        // 只要数量大于0，即是够了全选
        this.isCheckAll = selection && selection.length > 0;
      },
      open() {
        // 历史已经选择过的数据清空
        this.tableData = [];
        this.isSearch = false;
        this.dialogVisible = true;
        this.isCheckAll = false;
        this.keyword = '';
        this.pageInfo = {
          page: 1,
          limit: 10
        };
        this.getList(true, true);
      },
      saveCheckHandle() {
        let res = null;
        if (this.choseType == 'checkbox') {
          if (this.selectCoupons.length + this.selectTotal > 200) {
            this.$vhMessage.error(this.$t('host.k_576022'));
            return;
          }
          res = this.tableData.filter(item => {
            return this.selectCoupons.some(i => {
              return item.coupon_id == i;
            });
          });
        } else {
          this.tableData.map(item => {
            if (item.coupon_id == this.currentRadio) {
              res = [item];
            }
          });
        }

        this.$emit('selected', res);
        this.cancel();

        // let ids = res.map(item => {
        //   return item.coupon_id;
        // });

        // this.lotteryServer
        //   .checkCoupons({
        //     coupon_ids: ids
        //   })
        //   .then(res2 => {
        //     if (res2 && res2.code === 200) {
        //       let obj = res;
        //       if (res2.data) {
        //         obj = res.filter(e => {
        //           return res2.data.includes(parseInt(e.coupon_id + ''));
        //         });
        //       }

        //       this.$emit('selected', obj);
        //       this.cancel();
        //     }
        //   })
        //   .catch(res => {
        //     console.log(res);
        //     this.$vhMessage({
        //       message: res.message || `保存失败`,
        //       showClose: true,
        //       // duration: 0,
        //       type: 'error',
        //       customClass: 'zdy-info-box'
        //     });
        //     this.open();
        //   });
      },
      cancel() {
        this.selectCoupons = [];
        this.currentRadio = '';
        try {
          this.$refs.elTable.clearSelection();
        } catch (e) {
          console.log(e);
        }
        document.querySelector('.coupon-material .vh-table__body-wrapper').scrollTop = 0;
        this.dialogVisible = false;
      },
      // readonlyTable() {
      //   if (this.tableData.length > 0 && this.selectCoupons.length > 0) {
      //     for (let i = 0; i < this.tableData.length; i++) {
      //       if (this.selectCoupons.includes(this.tableData[i].coupon_id)) {
      //         this.$nextTick(() => {
      //           this.$refs.elTable.toggleRowSelection(this.tableData[i], true);
      //         });
      //       }
      //     }
      //   }
      // },
      openGoodsList(row) {
        if (row.applicable_product_type != 0) {
          this.curCouponId = parseInt(row.coupon_id + '');
          this.$nextTick(() => {
            console.log(this.curCouponId);
            this.$refs.goods.open();
          });
        }
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    }
  };
</script>

<style lang="less">
  .coupon-material {
    &-list {
      min-height: 378px;
      .vh-radio-group {
        width: 100%;
        max-width: 100%;
      }
      .vh-radio__label {
        display: none;
      }
      .vh-table td:first-child,
      .vh-table th:first-child {
        padding-left: 24px;
      }
    }
    &-header {
      padding-bottom: 24px;
    }
    .coupon-cover {
      width: 70px;
      height: 70px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &-footer {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      .footer-desc {
        line-height: 36px;
        color: #262626;
      }
      b {
        color: #fb2626;
      }
    }
    .highLight {
      color: #0a7ff5;
      cursor: pointer;
    }
  }
</style>
